const LEGEND_SELECTOR = '.star-rating-categories-legend-item';
const ARC_SELECTOR = '.MuiPieArc-root';

export const generateHoverSelectors = (count: number) => {
  const hover: string[] = [];
  const open: string[] = [];
  const arcHover: string[] = [];
  const arcToLegend: string[] = [];

  for (let i = 1; i <= count; i++) {
    hover.push(`&:has(${LEGEND_SELECTOR}:hover:nth-child(${i})) ${ARC_SELECTOR}:nth-child(${i})`);
    open.push(`&:has(${LEGEND_SELECTOR}[open]:nth-child(${i})) ${ARC_SELECTOR}:nth-child(${i})`);
    arcHover.push(`${ARC_SELECTOR}:hover:nth-child(${i})`);
    arcToLegend.push(
      `&:has(${ARC_SELECTOR}:hover:nth-child(${i})) div${LEGEND_SELECTOR}:nth-child(${i})`,
    );
  }

  return {
    hoverSelectors: hover.join(', '),
    openSelectors: open.join(', '),
    arcHoverSelectors: arcHover.join(', '),
    arcToLegendSelectors: arcToLegend.join(', '),
  };
};
